import { ArrowRight } from 'lucide-react';
import { useTeamLevel } from '../../../../application/hooks/team/useTeamQueries';
import { useTranslation } from '../../../../application/hooks/useTranslation';
import { QueryState } from '../../../components/feedback/QueryState';
import { Button } from '../../../components/ui/Button';
import { MemberCard } from '../navigator/MemberCard';

export interface TeamTabProps {
  userId: string;
  onOpenMember: (userId: string) => void;
  onFocusMember: (userId: string) => void;
}

/** Direct reports of the selected agent + a jump into the navigator at their level. */
export function TeamTab({ userId, onOpenMember, onFocusMember }: TeamTabProps) {
  const { t } = useTranslation();
  const level = useTeamLevel(userId);
  const items = level.data?.pages.flatMap((p) => p.items) ?? [];

  return (
    <div className="m360-team" data-testid="member360-team">
      <Button variant="secondary" size="sm" onClick={() => onFocusMember(userId)} data-testid="member360-open-navigator">
        {t('team.openInNavigator')} <ArrowRight size={14} aria-hidden />
      </Button>
      {level.isPending || level.error ? (
        <QueryState loading={level.isPending} error={level.error} onRetry={() => void level.refetch()} skeletonCount={2} />
      ) : items.length === 0 ? (
        <p className="m360-hint">{t('team.noReports')}</p>
      ) : (
        <ul className="tm-list">
          {items.map((card) => (
            <MemberCard key={card.id} card={card} compact onOpen={(c) => onOpenMember(c.apartmentId)} />
          ))}
        </ul>
      )}
    </div>
  );
}
